import { LegalSubSection } from '../models/legal-documents-metadata';

export function getSubSectionTitle(subSection: LegalSubSection) {
  const result = subSection.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}
